<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <el-form ref="form"
               :model="form"
               :rules="finCenterConfigRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="">

        <div class="re-el-form__flex">
          <div class="medium">
            <el-tooltip class="item"
                        effect="dark"
                        content="大于此金额时需要一级审批人进行审批"
                        placement="top-end">
              <el-form-item label="一级审批起始值"
                            key="approve_amount_lv1"
                            prop="approve_amount_lv1">
                <el-input v-model="form.approve_amount_lv1"
                          placeholder="输入一级审批起始值"></el-input>
              </el-form-item>
            </el-tooltip>

            <el-tooltip class="item"
                        effect="dark"
                        content="大于此金额时需要二级审批人进行审批"
                        placement="top-end">
              <el-form-item label="二级审批起始值"
                            key="approve_amount_lv2"
                            prop="approve_amount_lv2">
                <el-input v-model="form.approve_amount_lv2"
                          placeholder="输入二级审批起始值"></el-input>
              </el-form-item>
            </el-tooltip>

            <el-tooltip class="item"
                        effect="dark"
                        content="大于此金额时需要三级审批人进行审批"
                        placement="top-end">
              <el-form-item label="三级审批起始值"
                            key="approve_amount_lv3"
                            prop="approve_amount_lv3">
                <el-input v-model="form.approve_amount_lv3"
                          placeholder="输入三级审批起始值"></el-input>
              </el-form-item>
            </el-tooltip>

            <el-tooltip class="item"
                        effect="dark"
                        content="大于此金额时需要三级审批人进行审批"
                        placement="top-end">
              <el-form-item label="四级审批起始值"
                            key="approve_amount_lv4"
                            prop="approve_amount_lv4">
                <el-input v-model="form.approve_amount_lv4"
                          placeholder="输入四级审批起始值"></el-input>
              </el-form-item>
            </el-tooltip>

          </div>
        </div>

        <template>
          <el-button type="primary"
                     @click="onSubmit()">保存设置
          </el-button>
        </template>

      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { finCenterConfigRules } from '../finance-config.rules'

export default {
  data () {
    return {
      finCenterConfigRules,
      form: {
        approve_amount_lv1: 0,
        approve_amount_lv2: 0,
        approve_amount_lv3: 0,
        approve_amount_lv4: 0,
      },
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
      this.getConfig()
    },
    getConfig () {
      request.common('getFinCenterConfigs', {}).then(({data}) => {
        filter.setLoop(this.form, data)
      })
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.setConfig()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    setConfig () {
      request.common('setFinCenterConfigs', {...this.getForm()}).then((res) => {
        this.$message.success('设置成功')
      })
    },
    getForm () {
      return filter.copyJson(this.form)
    },
  },
}
</script>

<style lang="scss">
// 全局CSS
</style>

<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/finance-config/pages/FinanceApprovalValueConfig.vue